export enum VerticalType {
  NotSpecified = 0,
  Apartments = 1,
  Cannabis = 2,
  'Car Dealership' = 3,
  Construction = 4,
  Education = 5,
  Government = 6,
  HOA = 7,
  Hotel = 8,
  Manufacturing = 9,
  'Office Tower' = 10,
  Park = 11,
  'Parking Garage' = 12,
  'Scrap Metal' = 13,
  'Shopping Center' = 14,
  'Storage Facilities' = 15,
  Trucking = 16,
  Utilities = 17,
  'Wholesale/Distribution' = 18
}

export enum MonitoringType {
  NotSpecified = 0,
  Auto = 1,
  Cannabis = 2,
  Construction = 3,
  Fixed = 4,
  General = 5,
  'High Risk' = 6,
  Multifamily = 7,
  'Office Tower' = 8,
  'Parking Garage' = 9,
  'Shopping Centers' = 10,
  'Storage Facilities' = 11,
}

export enum DeviceType {
  NVR = 1,
  Camera = 2,
  NIC = 3,
  'Wireless Card' = 4,
  Alarm = 5,
  Module = 6,
  Input = 7,
  'SV.Operator Station' = 8,
  Output = 9,
  'API Service' = 10
}

export enum StatusType {
  'Not Specified' = 0,
  Active = 1,
  Discovered = 2,
  Inactive = 3,
  Cancelled = 4,
  Archived = 5
}

export enum ContactType {
  'Not Specified' = 0,
  'Installer' = 1,
  'Account Coordinator' = 2,
  'Account Executive' = 3,
  'Authorized User' = 4,
  'Emergency Contact' = 5,
  'Other' = 6,
  'Site Supervisor' = 7,
  'Sales Person' = 8,
  'Project Manager' = 9,
  'Primary Service Technician' = 10,
  'Secondary Service Technician' = 11,
  'Customer Success Specialist' = 12,
  'Account Owner' = 14,
  'Customer Success Manager' = 15,
}

export enum AlertType {
  'Not Specified' = 0,
  'Emergency' = 1,
  'Go Live' = 2,
  'Informational' = 3,
  'Video Review' = 4,
  'Worker Onsite' = 5,
  'High Alert' = 6,
  'CTA Attached' = 7,
  'Customer Site Disarm' = 8
}

export enum OutputType {
  NotSpecified = 0,
  Speaker = 1,
}

export enum TypeLookUp {
  SiteMap = 1,
  Alarm = 2,
  Alert = 3,
  Authority = 4,
  Contact = 5,
  Device = 6,
  Input = 7,
  Site = 8,
  Monitoring = 9,
  SubMonitoring = 10,
  Source = 11,
  PhoneNumber = 12,
  Status = 13,
  Vertical = 14,
  NVR = 15,
  Camera = 16,
  Nic = 17,
  OS = 18,
  NVRVersion = 19,
  Position = 20,
  CameraQuality = 21,
  ServiceZone = 22,
  MonitoringPlatform = 23,
  WirelessCarrier = 24,
  CameraBrand = 25,
  Login = 26,
  Incident = 27,
  Priority = 28,
  Output = 29,
  AvailableHours = 30,
  ContactClassification = 31,
  Installer = 32,
  Disposition = 33,
  InsuranceUnderwriter = 34,
  Contract = 35,
  ServicePlan = 36,
  GuardTour = 37,
  DeviceTag = 38,
  MonitoredBy = 39,
  PauseReason = 40,
  UnpauseReason = 41,
  WowzaStream = 42,
  ModuleType = 43,
  ProtocolType = 44,
  ActionOutcome = 45,
  SiteTag = 46,
  VendorServices = 47,
  ExpectedSiteActivity = 48,
  NVRConnection = 49,
  DetectionGroup = 50,
  AuxDesignation = 51,
  AuthorityOutcome = 52,
  NVRPort = 53,
  ActionOutcomeRemark = 54,
  EscalationGroup = 57,
  RemoteServer = 58,
  AddMonitoringHours = 59,
  RemoveMonitoringHours = 60,
  SiteAttachment = 61,
  SMTPServerType = 62
}

export enum SourceLookUp {
  NotSpecified = 0,
  SMI = 1,
  UCIT = 2,
  CMS = 3,
}

export enum NoteGroupTypeLookup {
  Customer = 1,
  Site = 2,
  Authority = 3,
  Contact = 4,
  Device = 5,
}

export enum CustomerNoteLookup {
  Note = 1,
  Alert = 2,
}

export enum SiteNoteTypeLookup {
  Note = 1,
  Alert = 2,
  'Property Note' = 3,
  'Suite Specific' = 4,
  Requirements = 5,
  'Known Areas of Site that are Vulnerable or at Risk' = 6,
  'Other Info' = 7,
  'Recent Activity or Threat' = 8,
  'Additional Security Detail' = 9,
  'Strobe Instruction' = 10,
  'Areas with Fencing' = 11,
  'Entrance' = 12,
  'Police Entrance' = 13,
  'Gate Lock' = 14,
  'Worker Schedule' = 15,
  'Site Down Protocol' = 16,
  'Phase Down Protocol' = 17,
  'PoleCam Down Protocol' = 18,
  'High Priority Cam' = 19,
  'Service' = 20,
}

export enum AuthorityNoteTypeLookup {
  'Note' = 1,
  'Special Instruction' = 2,
  'PreCall Instruction' = 3,
  'OnCall Instruction' = 4,
  'PostCall Instruction' = 5,
}

export enum ContactNoteTypeLookup {
  'Note' = 1,
}

export enum SiteMapTypeLookup {
  'Not Specified' = 0,
  'Authorized List' = 1,
  'Default Site Map' = 2,
  'Other Site Map' = 3,
}

export enum ServiceTicketStatusType {
  Tier1 = 1,
  Tier2 = 2,
  FieldService = 3,
  Fixed = 4,
  Closed = 5,
  Cancelled = 6,
  OnHold = 7,
  VideoReview = 8,
  Other = 9,
}

export enum ContactClassificationTypeLookup {
  None = 0,
  Monitoring = 1,
  Service = 2,
  Both = 3,
}

export enum PresetDropDownLookup {
  None = 0,
  OneHour = 1,
  TwelveHours = 2,
  OneDay = 3,
  ThirtyDays = 4,
  SixtyDays = 5,
  NinetyDays = 6,
}

export enum LoginTypeLookup {
  NotSpecified = 0,
  Admin = 1,
  Monitor = 2,
  ITStaff = 3,
  RTSP = 4,
  APIService = 5,
  SMTPConfiguration = 6,
  FTP = 7,
}

export enum CountryIdLookup {
  CA = 29,
  US = 187,
}

export enum MonitoringPlatformLookup {
  NotSpecified = 0,
  Detexi = 1,
  GeoVisionOpenPorts = 2,
  HIKVision = 3,
  Avigilon = 4,
  GeoVisionClosedPorts = 5,
  Orchid = 6,
  Luxriot = 7,
  AvigilonEdge = 8
}

export enum ModuleTypeLookup {
  NotSpecified = 0,
  ThreeCX = 1,
  IO = 2,
  Barix = 3,
}

export enum EnvironmentLookup {
  Production = 0,
  PreProd = 1,
  NotSpecified = 2,
  UAT = 3,
  DEV = 4,
}

export enum CameraTypeLookup {
  NotSpecified = 0,
  Fisheye = 1,
  Fixed = 2,
  PTZ = 3,
  Timelapse = 4,
  LPRWithSnapshots = 7,
}

export enum CredentialType
{
  Standard,
  Timelapse,
  LPRWithSnapshots   
}

export enum OptionDateTimeRangeValue {
  'No Filter' = 0,
  'Last 24 hours' = 1,
  'Last 7 days' = 2,
  'Last 30 days' = 3,
  'Last 90 days' = 4,
  'Last 365 days' = 5,
  'Custom' = 6,
}

export enum DiscoveredDevicesByLookUp {
  None = -1,
  Customer = 0,
  Site = 1,
  NVR = 2,
}

export enum VideoPorts {
  'PTZ' = 1,
  'Fixed' = 2,
  'Fisheye' = 3,
  'Axis 241Q 2.12 or higher' = 4,
  'Axis 2120 2.12 or higher' = 5,
  'SONY SNC-P1' = 6,
  'Axis 2130 2.12 or higher' = 7,
  'Pelco' = 8,
  'ONVIF' = 9,
}

export enum SiteProtocolContactType {
  AuthorityContact = 0,
  CustomerContact = 1,
  StealthContact = 2,
}

export enum SalesforceServiceTicketStatus {
  'All' = 1,
  'Open' = 2,
  'Assigned' = 3,
  'In Progress' = 4,
  'QA' = 5,
  'On Hold' = 6,
  'Closed' = 7,
}

export enum AppCatalogEnvLookup {
  DEV = "DEV",
  UAT = "UAT",
  QA = "QA",
  PREPROD = "PREPROD",
  PROD = "PROD",
}

export enum CreateEditProtocolSteps {
  Protocols = 1,
  Escalations = 2,
  ProtocolSteps = 3,
  Contacts = 4,
  Completed = 5
}

export enum MonitoredByLookup {
  NotSpecified = 0,
  StealthVision = 1,
  NonMonitored = 2,
  Geovision = 3,
  Detexi = 4,
  Immix = 5,
  SureviewStealth = 6,
  VirtualGuard = 7,
  Syncro = 8,
  SureviewCaliber = 9,
  PHImmix = 10,
  PendingGoLive = 11,
  EcamImmix = 12,
  EventQ = 13,
}

export enum SiteEnvIdLookup {
  'Production' = 0,
  'PreProd' = 1,
  'Not Specified' = -1
}

export enum SiteAttachmentLookup{
  'Authorized List' = 1,
  'BOLO' = 2,
  'Call List' = 3,
  'CTA' = 4,
  'SSF' = 5,
  'Other' = 6
}

export enum OverrideTypeLookup {
  'All' = 0,
  'Monitoring Schedule' = 1,
  'Guard Tour' = 2
}

export enum PhoneNumberTypeLookup {
  General = 1,
  Cell = 6,
  Fax = 9,
}

export type AdvancedFilters = string | null | undefined;
export type NumberFilters = number | null | undefined;
